import s3Overview from './overview.json';

import summaryS3Health from './widgets/summaryS3Health.json';

import s3ErrorsOverview from './widgets/errors/s3ErrorsOverview.json';
import s3ErrorsMaster from './widgets/errors/s3ErrorsMaster.json';
import s3ErrorsDetail from './widgets/errors/s3ErrorsDetail.json';
import s3ErrorsDetailTitle from './widgets/errors/s3ErrorsDetailTitle.json';
import s3EntityErrorRequestLatency from './widgets/errors/s3ErrorRequestLatency.json';
import s3ErrorRequests from './widgets/errors/s3ErrorRequests.json';
import s3EntityErrorSelectedBytes from './widgets/errors/s3ErrorSelectedBytes.json';

import s3RequestsOverview from './widgets/requests/s3RequestsOverview.json';
import s3RequestsMaster from './widgets/requests/s3RequestsMaster.json';
import s3RequestsDetail from './widgets/requests/s3RequestsDetail.json';
import s3RequestsDetailTitle from './widgets/requests/s3RequestsDetailTitle.json';
import s3EntityRequestSelects from './widgets/requests/s3RequestSelects.json';
import s3EntityRequestBytes from './widgets/requests/s3RequestBytes.json';
import s3RequestsByType from './widgets/requests/s3RequestsByType.json';

import filterS3Health from './widgets/filterS3Health.json';

export default [
  s3Overview,

  // Filters
  filterS3Health,

  // Widgets

  // summary
  summaryS3Health,

  // requests
  s3RequestsOverview,
  s3RequestsMaster,
  s3RequestsDetail,
  s3RequestsDetailTitle,
  s3EntityRequestSelects,
  s3EntityRequestBytes,
  s3RequestsByType,

  // errors
  s3ErrorsOverview,
  s3ErrorsMaster,
  s3ErrorsDetail,
  s3ErrorsDetailTitle,
  s3EntityErrorRequestLatency,
  s3ErrorRequests,
  s3EntityErrorSelectedBytes,
];
